import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { Typography } from '@saucelabs/ds-typography/lib';
import {
  records as appStorageRecords,
} from '@saucelabs/sl-module-app-storage';

import constants from '../constants';
import operations from '../operations';

type DeleteModalProps = {
  file: appStorageRecords.AppStorageFile | null;
};

const DeleteModalComponent: React.FC<DeleteModalProps> = ({ file }) => {
  const dispatch = useDispatch<ReduxDispatcher>();

  return (
    <Modal
      onConfirm={() => {
        if (file) {
          void dispatch(operations.deleteAndRefreshFiles(file));
        }
      }}
      title="Delete App Build"
    >
      {file && (
        <>
          <Typography>Are you sure you want to delete this build of the app?</Typography>

          <Typography>
            (File ID:
            <Typography
              className="font-bold"
              component="span"
            >
              {` ${file.id}`}
            </Typography>
            )
          </Typography>
        </>
      )}
    </Modal>
  );
};

const DeleteModal = modalConnectV2(
  constants.DELETE_FILE_MODAL_IDENTIFIER,
  DeleteModalComponent,
);

export default DeleteModal;
export {
  DeleteModalComponent,
};
